import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './../../services/auth.service';
import { UserType } from './../../models/user.model';
import { ErrorResponse } from './../../models/error.model';
import { Broker } from './../../models/broker.model';
import { BrokersService } from './../../services/brokers.service';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from 'src/app/services/utils.service';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from './../generics/data-table/data-table.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { ChangeEmailDialogComponent } from '../../dialogs/change-email-dialog/change-email-dialog.component';

@Component({
    selector: 'app-brokers',
    templateUrl: './brokers.component.html',
    styleUrls: ['./brokers.component.scss']
})
export class BrokersComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Número', prop: 'id', sortable: true },
        { name: 'Nombre', prop: 'nombre', sortable: true },
        { name: 'Apellido', prop: 'apellido', sortable: true },
        { name: 'E-Mail', prop: 'email', type: 'email', sortable: true },
        { name: 'CUIT', prop: 'cuit', type: 'cuit', sortable: true },
        { name: 'Teléfono', prop: 'celular', type: 'phone' },
        { name: 'Nro. oficina', prop: 'oficina.sucursal' },
        { name: '', width: '140px' }
    ];

    sortConfiguration?: SortConfiguration;

    brokers: Broker[];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre', type: 'STRING' },
        { key: 'apellido', description: 'Apellido', type: 'STRING' },
        { key: 'email', description: 'Email', type: 'STRING' },
        { key: 'cuit', description: 'CUIT', type: 'STRING' },
    ];
    filterValues: any = {};

    userType?: UserType;

    constructor(
        private brokersService: BrokersService,
        private authService: AuthService,
        private dialog: MatDialog,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getBrokers();
        this.userType = this.authService.getUser()?.tipo;
        if (this.userType !== 'OFICINA') {
            this.columns[this.columns.length - 1].width = '70px';
        }
    }

    getBrokers() {
        this.brokersService.getBrokers(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
            .subscribe(response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.brokers = response.body;
            }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener agentes', error.error?.descripcion));
    }

    updateBrokers(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getBrokers();
    }

    updateSort(event: SortConfiguration | undefined) {
        this.sortConfiguration = event;
        this.getBrokers();
    }

    deleteBroker(broker: Broker) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.brokersService.deleteBroker(broker.id).subscribe(_ => {
                    this.utilsService.alert('Agente borrado correctamente', `Se ha eliminado el agente ${broker.nombre} ${broker.apellido} de la plataforma.`);
                    this.getBrokers();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al borrar agente', error.error?.descripcion));
            }
        });
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getBrokers();
    }

    resetUserPassword(broker: Broker) {
        const alert = this.utilsService.confirm('¿Está seguro?', 'Se enviará un email al dueño de la cuenta para generar una nueva contraseña, esta acción no se puede deshacer.');
        alert.afterClosed().subscribe(result => {
            if (result) {
                this.authService.requestRecovery(broker.email, 'AGENTE').subscribe({
                    next: _ => this.utilsService.alert('Contraseña regenerada correctamente', 'Se ha enviado un email al email registrado con la nueva clave.'),
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al regenerar clave', error.error?.descripcion)
                });
            }
        });
    }

    changeEmail(broker: Broker) {
        this.dialog.open(ChangeEmailDialogComponent, { data: { email: broker.email } })
            .afterClosed().subscribe(result => {
                if (result) {
                    this.getBrokers();
                }
            });
    }
}
